import { Component, Input, OnInit } from '@angular/core';
import { PaymentStatusVariant } from '@shared/models/payment-status';

@Component({
    selector: 'app-payment-status',
    templateUrl: './payment-status.component.html',
    styleUrls: ['./payment-status.component.scss'],
    standalone: false
})
export class PaymentStatusComponent implements OnInit {
  @Input() premiumStatus: string;

  readonly paymentStatusVariant: typeof PaymentStatusVariant = PaymentStatusVariant;

  public badgeText: string;
  public variant: string;
  
  constructor() {
  }

  ngOnInit(): void {
    this.badgeText = !!this.premiumStatus ? 'payment-status.' + this.premiumStatus : 'common.null-string';
    this.variant = !!this.premiumStatus ? this.paymentStatusVariant[this.premiumStatus] : 'default';
  }

}
